// For ISCIR Authorizations
export const STAMP_EXPIRATION_YEARS = 1;
export const COUPON_EXPIRATION_YEARS = 4;
export const AUTHORIZATION_EXPIRATION_YEARS = 4;
// For Internal Authorizations
export const CERTIFICATE_EXPIRATION_YEARS = 1;

export const OFFSET_AUTHORIZATION_RENEWAL_WEEKS = 8;
export const OFFSET_COUPON_STAMP_RENEWAL_WEEKS = 2;
export const OFFSET_COUPON_RENEWAL_WEEKS = 8;


export const DataRefreshInterval = {
    // clientsSec: 60 * 5,
    // employersSec: 60 * 5,
    clientsSec: 60 * 60 * 2,            // 2 hours
    employersSec: 60 * 60,              // 60 minutes
    generalSec: 60 * 5                  // 60 (5) minutes
}
